export type ValueOf<T> = T[keyof T];

export const NotificationType = Object.freeze({
	WEBPUSH : 'WEBPUSH',
	EMAIL : 'EMAIL',
	APP: 'APP',
	NATIVE: 'NATIVE',
});

export type NotificationTypeValues = ValueOf<typeof NotificationType>;
export type NotificationTypeKeys = keyof typeof NotificationType;